import { c as _c } from "react/compiler-runtime";
import { useAppSelector } from "@store/store-helper";
import { fetchingTeamsFlagsSelector } from "@store/teams/teams-selector";
import { useMediaQueryList } from "@hooks/use-media-query";
import { TeamsEmptyPage } from "@pages/members/teams/teams-empty-page";
import { TeamsMobileView } from "@pages/members/teams/teams-mobile-view";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { TEAMS_TABLE_COLUMNS } from "@components/table/teams/teams-table-constants";
import { TeamsTable } from "@components/table/teams/teams-table";
/** Wrapper component for the TeamsTable that handles different views and empty states */
export function TeamsTableWrapper(t0) {
  const $ = _c(15);
  const {
    companyId,
    sortedTeams,
    buttonComponents,
    sortBy,
    setSortBy
  } = t0;
  const {
    status
  } = useAppSelector(fetchingTeamsFlagsSelector);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const shouldShowEmptyPage = sortedTeams.length === 0 && status === "succeeded" || status === "rejected";
  const isLoading = status === "pending";
  if (shouldShowEmptyPage) {
    let t1;
    if ($[0] !== status) {
      t1 = <TeamsEmptyPage status={status} />;
      $[0] = status;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (isScreenSmOrSmaller) {
    let t1;
    if ($[2] !== isLoading || $[3] !== sortBy || $[4] !== sortedTeams) {
      t1 = <TeamsMobileView teams={sortedTeams} isLoading={isLoading} sortBy={sortBy} />;
      $[2] = isLoading;
      $[3] = sortBy;
      $[4] = sortedTeams;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  let t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [...TEAMS_TABLE_COLUMNS];
    t2 = {
      nonConfigurableColumns: ["options"],
      defaultVisibleColumns: ["name", "users", "creationDate", "workspaceRole"]
    };
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  let t3;
  if ($[8] !== buttonComponents || $[9] !== companyId || $[10] !== isLoading || $[11] !== setSortBy || $[12] !== sortBy || $[13] !== sortedTeams) {
    t3 = <ColumnPreferencesProvider tableKey="teams-table" columns={t1} options={t2}><TeamsTable companyId={companyId} teams={sortedTeams} isLoading={isLoading} bulkActionButtons={buttonComponents} sortBy={sortBy} setSortBy={setSortBy} /></ColumnPreferencesProvider>;
    $[8] = buttonComponents;
    $[9] = companyId;
    $[10] = isLoading;
    $[11] = setSortBy;
    $[12] = sortBy;
    $[13] = sortedTeams;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}